import type { CSSProperties } from 'react'
import type { SxProps, Theme } from '@mui/material'

export const containerSx: SxProps<Theme> = {
  py: 4,
}

export const backLinkSx: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.5,
  mb: 3,
  textDecoration: 'none',
  color: 'primary.main',
  '&:hover': {
    textDecoration: 'underline',
  },
}

export const backIconSx: SxProps<Theme> = {
  fontSize: 18,
}

export const titleSx: SxProps<Theme> = {
  fontWeight: 600,
  mb: 4,
}

export const sectionSx: SxProps<Theme> = {
  mb: 1,
  fontSize: '0.875rem',
  lineHeight: 1.8,
  '& code': {
    fontFamily: 'monospace',
    fontSize: '1.05em',
    color: (theme) =>
      theme.palette.mode === 'dark' ? theme.palette.error.light : theme.palette.error.main,
  },
}

export const sectionTitleSx: SxProps<Theme> = {
  fontWeight: 600,
  fontSize: '1.05rem',
  mb: 2,
  scrollMarginTop: 80,
}

export const dividerSx: SxProps<Theme> = {
  my: 4,
  borderColor: 'divider',
  opacity: 0.3,
}

export const inlineLinkSx: SxProps<Theme> = {
  color: 'primary.main',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
  '&:focus-visible': {
    outline: '2px solid',
    outlineColor: 'primary.main',
    outlineOffset: '2px',
    borderRadius: '2px',
  },
}

export const listStyle: CSSProperties = {
  margin: 0,
  paddingLeft: 20,
}
